import React, { Component } from 'react';
import { Form, InputNumber, Button, Row, Col, Select, message, DatePicker, Alert } from 'antd';
import { connect } from 'react-redux';
import * as actions from '../redux/actions/report';
import * as agentActions from '../redux/actions/agents';
import moment from 'moment';

class Sms extends Component {
    formRef = React.createRef();
    state = {
        startDate: null,
        endDate: null
    }
    onFinish = (values) => {
        this.props.onGet(values.agent, this.state.startDate, this.state.endDate, this.props.token);
    };

    onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };
    onSave = async (values) => {
        let result = this.props.agents.filter(agent => agent.id == this.props.report.agentId);
        for (let i in result) {
            await this.props.onSend(this.props.report, this.props.token);
        }
        await this.props.onGetAgent(this.props.token);
        if (this.props.message) {
            message.success(this.props.message);
        }
        if (this.props.error) {
            message.error(this.props.error);
        }
        this.formRef.current.resetFields();
    }
    dateHandler = (value, dateString) => {
        this.setState(prevState => {
            return {
                ...prevState,
                startDate: dateString[0],
                endDate: dateString[1]
            }
        });
    }
    disabledDate = (current) => {
        return current && current < moment(this.props.lastReportedDate, "DD-MM-YYYY").add(1, 'days');
    }
    handleSelectAgent = (value) => {
        let selectedAgentArr = this.props.agents.filter(agent => agent.id === value);
        let lastDate = selectedAgentArr[0].lastReportedDate;
        let formattedDate = moment(lastDate).locale('my').format('DD-MM-YYYY');
        this.props.onChange(formattedDate);
    }
    render() {
        const { RangePicker } = DatePicker;
        const { Option } = Select;
        let formItems = null;
        let form = null;
        let openingBalance = null;
        let closingBalance = null;
        const agents = this.props.agents
            .filter(agent => {
                let today=moment(new Date()).format('YYYY-MM-DD');
                let lastday=moment(agent.lastReportedDate).format('YYYY-MM-DD');
                return !moment(today).isSameOrBefore(lastday);
            })
            .map(agent => {
                return (<Option key={agent.id} value={agent.id}>{agent.name}</Option>);
            });
        if (this.props.report) {

            openingBalance = (<Row gutter={4}>
                <Col>
                    <Form.Item
                        labelCol={{ span: 10 }}
                        wrapperCol={{ span: 14 }}
                        label="OpeningBalance"
                    >
                        <InputNumber style={{ width: '200px', color: '#08c' }}
                            defaultValue={this.props.report.openingBalance}
                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            disabled />
                    </Form.Item>
                </Col>
            </Row>);

            closingBalance = (<Row gutter={4}>
                <Col>
                    <Form.Item
                        labelCol={{ span: 10 }}
                        wrapperCol={{ span: 14 }}
                        label="ClosingBalance"
                    >
                        <InputNumber style={{ width: '200px', color: '#08c' }}
                            defaultValue={this.props.report.closingBalance}
                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            disabled />
                    </Form.Item>
                </Col>
            </Row>);
            let i = 0;
            formItems = this.props.report.productReports.map(product => {
                return (
                    <Row gutter={4}>
                        <Col>
                            <Form.Item
                                labelCol={{ span: 12 }}
                                wrapperCol={{ span: 12 }}
                                key={product.name}
                                label={product.name}
                                name={'product' + i++}
                            >
                                <InputNumber
                                    style={{ width: '200px', color: '#08c' }}
                                    defaultValue={product.winLoseAmount}
                                    formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                    disabled />
                            </Form.Item>
                        </Col>
                    </Row>
                )
            });
        }
        if (formItems) {
            form = <Form
                key={Math.random()}
                name="report"
                onFinish={this.onSave}
            >
                {openingBalance}
                {formItems}
                {closingBalance}
                <Form.Item wrapperCol={{ offset: 3 }}>
                    <Button type="primary" htmlType="submit">
                        Send Message
                    </Button>
                </Form.Item>
            </Form>
        }
        return (
            <>
                <h1 style={{ paddingLeft: '40px', fontSize: '24px' }}>Get Report</h1>
                <Alert style={{ width: '460px', marginLeft: '120px', marginBottom: '20px' }} message="Click REPORT Button before sending SMS" type="warning" showIcon closable />
                <Row justify="left" align="middle" style={{ paddingLeft: '60px' }}>
                    <Col lg={20} sm={20}>
                        <Form
                            name="basic"
                            layout="inline"
                            onFinish={this.onFinish}
                            onFinishFailed={this.onFinishFailed}
                            ref={this.formRef}
                        >
                            <Form.Item
                                style={{ width: '200px' }}
                                label="Agent"
                                name="agent"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Select agent',
                                    },
                                ]}
                            >
                                <Select
                                    showSearch
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                    onChange={this.handleSelectAgent}
                                >
                                    {agents}
                                </Select>
                            </Form.Item>
                            <Form.Item
                                name="dates"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Select dates',
                                    },
                                ]}
                            >
                                <RangePicker onChange={this.dateHandler}
                                    format="DD-MM-YYYY"
                                    disabledDate={this.disabledDate} />
                            </Form.Item>
                            <Form.Item >
                                <Button type="primary" htmlType="submit">
                                    Report
                            </Button>
                            </Form.Item>
                        </Form>
                    </Col>
                </Row>
                <br />
                <h2 style={{ paddingLeft: '40px' }}>Products:</h2>
                <Row justify="left" align="middle" style={{ paddingLeft: '60px' }}>
                    <Col Col lg={16} sm={20}>
                        {form}
                    </Col>
                </Row>
            </>
        );
    }

};
const mapStateToProps = state => {
    return {
        lastReportedDate: state.agents.lastReportedDate,
        token: state.auth.token,
        agents: state.agents.agents,
        report: state.report.report,
        message: state.report.message,
        error: state.report.error
    }
}
const mapDispatchToProps = dispatch => {
    return {
        onGet: (agentId, startDate, endDate, token) => dispatch(actions.getReport(agentId, startDate, endDate, token)),
        onSend: (report, token) => dispatch(actions.sendSms(report, token)),
        onChange: (date) => dispatch(agentActions.setLastReportedDate(date)),
        onGetAgent: (token) => dispatch(agentActions.getAgents(token))
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(Sms);